import { watch, onUnmounted, type Ref } from 'vue';

/**
 * Calls the handler when Escape is pressed while the ref is truthy.
 */
export function useEscapeKey(isOpen: Ref<boolean>, handler: () => void) {
  function onKeydown(e: KeyboardEvent) {
    if (e.key === 'Escape') {
      handler();
    }
  }

  watch(isOpen, (open) => {
    if (open) {
      document.addEventListener('keydown', onKeydown);
    } else {
      document.removeEventListener('keydown', onKeydown);
    }
  });

  onUnmounted(() => {
    document.removeEventListener('keydown', onKeydown);
  });
}
